(function () {
    'use strict';

    var module = angular.module('uwAgenda.global', [
        'ngRoute',
        'ngResource',
        'ngTouch',
        'ngStorage',
        'ngSanitize',
        'ui.router',
        'ui.bootstrap',
        'pascalprecht.translate',
        'ncy-angular-breadcrumb',
        'oc.lazyLoad',
        'ui.select'
    ]);



    // constants
    module.constant('SharedAgendaBroadcast', {
        "AgendaChanged": "agenda:changed",
        "AgendaOwnerLoaded": "currentOwner:loaded",
        'AgendaOwnerChanged': 'currentOwner: changed',
        "UpdateUI": "update:ui",
        "BadgeUpdate": "update:badges"
    });

    module.constant('DayTaskBroadcast', {
        "DayTasksFiltered": "daytasks:filtered"
    });

    module.constant('ViewsBroadcast', {
        'ViewsRefreshed': 'views-refreshed',
        'ViewSelected': 'view-selected'
    });

    // constants
    module.constant('MultipleFileUploadBroadcast', {
        "UpdateFileList": "update:filelist"
    });

    // constants
    module.constant('SummernoteBroadcast', {
        "Append": "summernote:append"
    });

    module.constant('ExternalPatientBroadcast', {
        'clear': 'external-clear',
        'set': 'external-set'
    });

})();